import { DASHBOARD_MODELS_ACTION_TYPES } from '@constants/actionTypes/dashboardActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case DASHBOARD_MODELS_ACTION_TYPES.SET_DASHBOARD_MODELS:
            return action && action.dashboardModels;
        case DASHBOARD_MODELS_ACTION_TYPES.CHANGE_DASHBOARD_MODELS:
            return action && action.newState;
        case DASHBOARD_MODELS_ACTION_TYPES.CLEAR_DASHBOARD_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};